
import ListV3 from './components/ListV3';

export default {
  i18nComponentKey: 'WidgetProductReviewsListV3.WidgetProductReviewsListV3Mobile',
  name: 'WidgetProductReviewsListV3Mobile',
  components: { ListV3 }
};
